import { fork, call, put, select } from 'redux-saga/effects'
import { takeLatest } from 'redux-saga'
import { normalize, arrayOf } from 'normalizr'

import * as fromSearch from '@src/redux/modules/search'
import * as fromAuth from '@src/redux/modules/auth'
import { aliadas } from '@src/services/api'
import { ALIADA } from '@src/services/api/schemas'
import { analytics } from '@src/services/Analytics'
import * as qs from 'utils/querystring'

export function collectAnalytics ({querystring = '', normalizedResults}) {
  const sortedBy = qs.parse(querystring).sort || 'by_finished_services'
  const results = normalizedResults.result.map((aliadaId) => {
    const aliada = normalizedResults.entities.aliadas[aliadaId]
    return {
      aliadaId,
      servicePrice: aliada.serviceCost,
      rating: aliada.averageRating,
      servicesFinished: aliada.finishedServicesCount
    }
  })

  analytics.searchResults({
    sortedBy,
    results,
    resultsCount: results.length
  })
}

// Sagas
export function * search (action) {
  yield put({type: fromSearch.SEARCH_STARTED})

  let { querystring } = action.payload

  const userId = yield select(fromAuth.getCurrentUser)

  if (userId) {
    const queryobject = qs.parse(querystring)
    queryobject.userId = userId
    querystring = qs.stringify(queryobject)
  }

  const { response, error } = yield call(aliadas.search, querystring)
  if (error) {
    return yield put({
      type: fromSearch.SEARCH_ERROR,
      payload: error,
      error: true
    })
  }

  const normalizedResults = normalize(response.results, arrayOf(ALIADA))

  yield put({
    type: fromSearch.SEARCH_SUCCESS,
    payload: {
      querystring,
      status: response.status,
      ...normalizedResults
    }
  })

  yield fork(collectAnalytics, { querystring, normalizedResults })
}

export function * searchMyAliadas (action) {
  const userId = yield select(fromAuth.getCurrentUser)
  if (!userId) {
    return
  }

  yield put({type: fromSearch.SEARCH_MY_ALIADAS_STARTED})

  const { querystring: querystringWithoutPrevUser } = action.payload
  const queryobject = qs.parse(querystringWithoutPrevUser)
  queryobject.previouslyServedUser = userId
  queryobject.userId = userId
  const querystring = qs.stringify(queryobject)

  const { response, error } = yield call(aliadas.search, querystring)
  if (error) {
    return yield put({
      type: fromSearch.SEARCH_MY_ALIADAS_ERROR,
      payload: error,
      error: true
    })
  }

  const normalizedResults = normalize(response.results, arrayOf(ALIADA))

  yield put({
    type: fromSearch.SEARCH_MY_ALIADAS_SUCCESS,
    payload: {
      ...normalizedResults
    }
  })

  yield fork(collectAnalytics, { querystring, normalizedResults })
}

// Sagas - Watchers
export function * watchSearch () {
  yield fork(takeLatest, fromSearch.SEARCH, search)
  yield fork(takeLatest, fromSearch.SEARCH_MY_ALIADAS, searchMyAliadas)
}

// Sagas - Root Saga
export default function * rootSaga () {
  yield * [
    fork(watchSearch)
  ]
}



// WEBPACK FOOTER //
// ./src/redux/sagas/search.js